import Typography from "@mui/material/Typography";

const AccordionTitle = ({ text, sx }) => {
  return <Typography className="accordionTitle" sx={sx}>{text}</Typography>;
};

export default AccordionTitle;
